import { Form } from 'antd';
import React from 'react';

function ResetPassword() {
	return <Form></Form>;
}

export default ResetPassword;
